export default "__VITE_ASSET__HUDoLZQ9__"